import React from 'react'

const NotificationListingPage = () => {
  return <h1>Notification listing</h1>
}

export default NotificationListingPage
